
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-chat/material/customization",
      function () {
        return require("private-next-pages/x/react-chat/material/customization.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-chat/material/customization"])
      });
    }
  